export const lendingTypes = {
  residential: 'RES',
};
